import { Component, Input, signal } from '@angular/core';
import { FaqModel } from '../../models/faq.model';
import { MatExpansionModule } from '@angular/material/expansion';
import { InnerHtmlComponent } from '../inner-html/inner-html.component';

@Component({
  selector: 'app-faq-list',
  standalone: true,
  imports: [MatExpansionModule, InnerHtmlComponent],
  templateUrl: './faq-list.component.html',
  styleUrl: './faq-list.component.scss',
})
export class FaqListComponent {
  @Input() faqs: FaqModel[] = [];

  readonly panelOpenState = signal(false);
}
